import React from 'react';
import MDX from '../../components/MDX';

const LessonMarkdown = (props) => <MDX className="prose lg:prose-lg" {...props} />;

export default LessonMarkdown;
